import { State, Action, StateContext, Selector, Store, Select } from '@ngxs/store';
import { patch } from '@ngxs/store/operators';
import { Injectable } from '@angular/core';
import * as PricelistCurrentActions from './pricelist-current.action';
import { PricelistCurrentService } from './pricelist-current.service';
import { BannerService } from '../../shared/services/banner.service';
import { HelperService } from '../../../../src/app/services/helper/helper.service';
import { empty } from 'rxjs';
import { SaveState } from '../../models/commonModels';
import { saveAs } from 'file-saver';
import * as PricelistCurrentModels from '../../models/pricelist-current/pricelist-current';
import { PricelistCurrentSearchModel } from '../../models/pricelist-current/pricelist-currentSearch';
import * as BaseStateModels from '../BaseState';
import { StorageService } from '../../shared/services/storage.service';
export interface PricelistCurrentStateModel extends BaseStateModels.BaseStateInterface {
    PricelistCurrent: PricelistCurrentModels.PricelistCurrentModel;
    Save: SaveState;
    Search: PricelistCurrentSearchModel;
    List: PricelistCurrentModels.PricelistCurrentListModel;
    MarkedTyres: PricelistCurrentModels.PricelistCurrentModel[];
    XlsOfferPreparing: boolean;
    PdfOfferPreparing: number;
    FilteredXlsLoading: boolean;
    FilteredCustomerXlsLoading: boolean;
  }

@State<PricelistCurrentStateModel>({
    name: 'pricelistCurrentState',
    defaults: {
      PricelistCurrent: null,
      Save: null,
      Search: null,
      List: null,
      MarkedTyres: new Array(),
      XlsOfferPreparing: null,
      PdfOfferPreparing: null,
      FilteredXlsLoading: null,
      FilteredCustomerXlsLoading: null,
      Report : null
    }
  })

  @Injectable()

export class PricelistCurrentState extends BaseStateModels.BaseState<PricelistCurrentStateModel> {

    constructor(
                private helperService: HelperService,
                private pricelistCurrentService: PricelistCurrentService,
                private bannerService: BannerService,
                private storageService: StorageService
    ) {
      super();
    }

  @Selector()static XlsOfferPreparing(state: PricelistCurrentStateModel) {
    return state.XlsOfferPreparing;
  }

  @Selector()static PdfOfferPreparing(state: PricelistCurrentStateModel) {
    return state.PdfOfferPreparing;
  }

  @Selector()static FilteredXlsLoading(state: PricelistCurrentStateModel) {
    return state.FilteredXlsLoading;
  }

  @Selector()static FilteredCustomerXlsLoading(state: PricelistCurrentStateModel) {
    return state.FilteredCustomerXlsLoading;
  }

  @Selector()
  static MarkedTyres(state: PricelistCurrentStateModel) {
    return state.MarkedTyres;
  }

  @Selector()
  static List(state: PricelistCurrentStateModel) {
    return state.List;
  }

  @Selector()
  static PricelistCurrent(state: PricelistCurrentStateModel) {
    return state.PricelistCurrent;
  }

  @Selector()
  static Save(state: PricelistCurrentStateModel) {
    return state.Save;
  }

  @Selector()
  static Search(state: PricelistCurrentStateModel) {
    return state.Search;
  }

  @Selector()
  static Report(state: PricelistCurrentStateModel) {
    return state.Report;
  }

  @Action(PricelistCurrentActions.SetSearch)
  setSearch(
    context: StateContext<PricelistCurrentStateModel>,
    action: PricelistCurrentActions.SetSearch
  ) {

    action.Search.CurrentPage = 1;

    context.setState(
      patch({
        Search: action.Search,
        MarkedTyres: new Array()
      }));

    context.dispatch(new PricelistCurrentActions.GetList(action.Search));
  }

  @Action(PricelistCurrentActions.SetListPage)
  setListPage(
    context: StateContext<PricelistCurrentStateModel>,
    action: PricelistCurrentActions.SetListPage
  ) {

    context.setState(
      patch({
        Search: action.Search
      }));

    context.dispatch(new PricelistCurrentActions.GetList(action.Search));
  }

  @Action(PricelistCurrentActions.ResetSearch)
  resetSearch(
    context: StateContext<PricelistCurrentStateModel>
  ) {

    const s = context.getState();

    const search = new PricelistCurrentSearchModel();

    search.ItemsPerPage = s.Search.ItemsPerPage;

    context.setState(
      patch({
        Search: search,
        MarkedTyres: new Array()
      }));

    context.dispatch(new PricelistCurrentActions.GetList(search));
  }

  @Action(PricelistCurrentActions.GetList)
  getList(
    context: StateContext<PricelistCurrentStateModel>,
    action: PricelistCurrentActions.GetList
  ) {

    const errorMessage = 'Błąd pobierania aktualnego cennika.';

    context.setState(
      patch({
        List: null
      })
    );

    this.pricelistCurrentService.get(action.Search).subscribe((ret) => {
          if (ret.Success) {
            context.setState(
              patch({
                List: ret
              })
            );
            return ret;
            } else {
              this.bannerService.error(ret.Message, errorMessage);
            }
          },
          (error) => {
            this.helperService.SaveException('PricelistCurrentActions.GetList', error);
            this.bannerService.error(errorMessage);
        });
  }

  @Action(PricelistCurrentActions.ClearListPromoCode)
  ClearListPromoCode(
    context: StateContext<PricelistCurrentStateModel>,
    action: PricelistCurrentActions.ClearListPromoCode
  ) {

    const errorMessage = 'Błąd zerowania kodów promocyjnych aktualnego cennika.';

    context.setState(
      patch({
        List: null
      })
    );

    this.pricelistCurrentService.ClearListPromoCode(action.Search).subscribe((ret) => {

      this.PatchReportContext(action.ReportName, false, context);

      if (ret.Success) {
        context.setState(
          patch({
            List: ret
          })
        );
        return ret;
      } else {
        this.bannerService.error(ret.Message, errorMessage);
      }
    },
      (error) => {

        this.PatchReportContext(action.ReportName, false, context);

        this.helperService.SaveException('PricelistCurrentActions.ClearListPromoCode', error);
        this.bannerService.error(errorMessage);
      });
  }

  @Action(PricelistCurrentActions.SetMarkList)
  setMarkList(
    context: StateContext<PricelistCurrentStateModel>,
    action: PricelistCurrentActions.SetMarkList
  ) {
    context.getState();

    // const errorMessage = 'errorMessage';

    context.setState(
      patch({
        MarkedTyres: new Array()
      })
    );

    if (action.AdditionalData) {
      if (action.AdditionalData.length > 0) {
        context.setState(
          patch({
            MarkedTyres: action.AdditionalData
          })
        );
      } else {
        // this.bannerService.error(errorMessage);
      }
    }
  }

  @Action(PricelistCurrentActions.GetOfferXLS)
  getOfferXLS(
        context: StateContext<PricelistCurrentStateModel>,
        action: PricelistCurrentActions.GetOfferXLS
     ) {
          function patchContext( loading: boolean) {
            context.setState(
              patch ({
                XlsOfferPreparing: loading
              })
            );
          }

          const fileName = 'Oferta';
          const custtomerId = action.AdditionalData.CustomerId;

          this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

          this.pricelistCurrentService.getOfferXLS(action.AdditionalData).subscribe (
                res => {
                  const file = new File([res], `${fileName}-${custtomerId}-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                  saveAs(file);
                  patchContext(false);
                },
                res => {
                  patchContext(false);
                  this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
                },
                () => {
                  patchContext(false);
                  this.helperService.consoleLog(' @Action(SpecificationActions.GetSpecificationReportReplacementAndSeasoning)');
                }
            );
  }

  @Action(PricelistCurrentActions.GetOfferPDF)
  GetOfferPDF(
    context: StateContext<PricelistCurrentStateModel>,
    action: PricelistCurrentActions.GetOfferPDF
  ) {

    function patchContext( loading: number) {
      context.setState(
        patch ({
          PdfOfferPreparing: loading
        })
      );
    }

    const fileName = 'Oferta';
    const custtomerId = action.AdditionalData.CustomerId;

    this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

    this.pricelistCurrentService.getOfferPdf(action.AdditionalData).subscribe(ret => {
      const file = new File([ret], `${fileName}-${custtomerId}-${this.helperService.TimeStamp()}.pdf`, { type: 'application/pdf' });
        // const file = new File([ret], `Depozyty-${this.helperService.TimeStamp()}.pdf`,
        // { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
      saveAs(file);
      patchContext(Math.random());
      },
        (error) => {
          patchContext(Math.random());
          this.helperService.SaveException('PricelistCurrentActions.GetOfferPDF', error);
          this.bannerService.error('Błąd pobierania pliku pdf.');
        },
      () => {
          patchContext(Math.random());
        }
      );
  }

  @Action(PricelistCurrentActions.SendOfferPDF)
  sendOfferPDF(
    context: StateContext<PricelistCurrentStateModel>,
    action: PricelistCurrentActions.SendOfferPDF
  ) {

    function patchContext( loading: number) {
      context.setState(
        patch ({
          PdfOfferPreparing: loading
        })
      );
    }

    const custtomerId = action.AdditionalData.CustomerId;
    const errorMessage = 'Wiadomość zawierająca ofertę nie została wysłana poprawnie.';


    this.pricelistCurrentService.sendOfferPdf(action.AdditionalData).subscribe(
      (ret) => {
        this.bannerService.info(`Oferta została wysłana`);
      },
      (error) => {
        this.helperService.SaveException('PricelistCurrentActions.SendOfferPDF', error);
        this.bannerService.error(`${errorMessage} ${error}`);
      }
    );
  }

  @Action(PricelistCurrentActions.GetReportFiltered)
  getReportFiltered(
    context: StateContext<PricelistCurrentStateModel>,
    action: PricelistCurrentActions.GetReportFiltered
  ) {

      function patchContext( loading: boolean) {
            context.setState(
              patch ({
                FilteredXlsLoading: loading
              })
            );
          }


      patchContext(true);
      const fileName = 'Cennik-opony';
      this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

      this.pricelistCurrentService.getReport(action.search).subscribe (
        res => {
                  const file = new File([res], `${fileName}-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                  saveAs(file);
                  patchContext(false);
        },
        res => {
                  patchContext(false);
                  this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
                },
                () => {
                  patchContext(false);
                }
        );
  }

  @Action(PricelistCurrentActions.GetCustomerReportFiltered)
  GetCustomerReportFiltered(
    context: StateContext<PricelistCurrentStateModel>,
    action: PricelistCurrentActions.GetReportFiltered
  ) {

      function patchContext( loading: boolean) {
            context.setState(
              patch ({
                FilteredCustomerXlsLoading: loading
              })
            );
          }


      patchContext(true);
      const fileName = 'Cennik-klient-opony';
      this.bannerService.info(`Rozpoczęto generowanie pliku raportu ${fileName}, proszę czekać ...`, 'Export danych');

      this.pricelistCurrentService.getCustomerReport(action.search).subscribe (
        res => {
                  const file = new File([res], `${fileName}-${this.helperService.TimeStamp()}.xlsx`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });
                  saveAs(file);
                  patchContext(false);
        },
        res => {
                  patchContext(false);
                  this.bannerService.error(`Błąd pobierania raportu: ${fileName}`);
                },
                () => {
                  patchContext(false);
                }
        );
  }

  @Action(PricelistCurrentActions.DisposeSearch)
  disposeSearch(
      context: StateContext<PricelistCurrentStateModel>
    ) {

      context.setState(
        patch({
          Search: null
        }));
  }

  @Action(PricelistCurrentActions.ImportPromoCode)
  ImportPromoCode(
    context: StateContext<PricelistCurrentStateModel>,
    action: PricelistCurrentActions.ImportPromoCode
  ) {


    this.bannerService.quickInfo('Rozpoczęto import kodów promocyjnych, proszę czekać.');

    this.PatchReportContext(action.ReportName, true, context);

    let fileName = action.FormData.get('fileName').toString();

    this.pricelistCurrentService.ImportPromoCode(action.FormData).subscribe(ret => {

      const processed = ret.headers.get('x-import-processed');
      const error = ret.headers.get('x-import-error');
      const result = ret.headers.get('x-import-result');
      const message = ret.headers.get('x-import-message');
      const imported = Number(ret.headers.get('x-import-imported'));

      this.PatchReportContext(action.ReportName, false, context);

      if (result === 'OK') {

        const file = new File([ret.body], `Wynik-Importu-${this.helperService.TimeStamp()}-${fileName}`, { type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' });

        if (imported > 0) {
          this.bannerService.instantSuccess(`Zakończono import pliku <b>${fileName}</b><br/><b>Zaimportowano ${imported}</b> pozycji.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }
        else {
          this.bannerService.instantMessage(`Zakończono import pliku <b>${fileName}</b><br/><b>Nie zaimporotwano żadnych pozycji</b>.<br/>Przetworzono <b>${processed}</b> wierszy.<br/>Znaleziono <b>${error}</b> wierszy z błędami.`);
        }

        saveAs(file);

      } else {

        if (message === 'IMPORT_EXCEPTION_EMPTY_FILE') {
          this.bannerService.instantError(`Zakończono import pliku <b>${fileName}</b><br/>Plik przeznaczony do importu jest pusty.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_FILE_EXTENSION') {
          this.bannerService.instantError(`Zakończono import pliku <b>${fileName}</b><br/>Plik przeznaczony do importu ma niewłaściwe rozszerzenie.`);
        } else if (message === 'IMPORT_EXCEPTION_INVALID_HEDER') {
          this.bannerService.instantError(`Zakończono import pliku <b>${fileName}</b><br/>Plik przeznaczony do importu ma niewłaściwy nagłówek.`);
        } else {
          this.bannerService.instantError(`Zakończono import pliku <b>${fileName}</b><br/>Wystąpił nieznany błąd podczas przetwarzania pliku.`);
        }
      }
    },
      (error) => {

        this.helperService.SaveException('TyreSupplierDiscountAction.ImportTyreSupplierDiscounts', error);

        this.bannerService.error('Błąd importu kodów promocyjnych.');

        this.PatchReportContext(action.ReportName, false, context);
      },
      () => {
        this.PatchReportContext(action.ReportName, false, context);

        this.helperService.consoleLog(
          "@Action(TyreSupplierDiscountAction.ImportTyreSupplierDiscounts)"
        );
      }
    );
  }
}
